export default __webpack_public_path__ + "static/media/alarm-truck-horn-called-open.f02ed8a1.mp3";